import React from "react";
import styles from "./DigitalBildung.module.css";

export default function DigitalBildung() {
  return (
    <section className={styles.hero}>

      <div className={styles.tag}>
        MODERN. DİGİTAL. INTERKULTURELL.
      </div>


      <h1>
        Digitale Bildung für
        <br />
        eine moderne Zukunft
      </h1>



      <div className={styles.contentArea}>


        {/* SOLDA KARTLAR */}
        <div className={styles.cards}>


          <div className={styles.card}>

            <div className={styles.icon}>
              🖥️
            </div>

            <h3>
              Interaktive
              Smartboards
            </h3>

            <p>
             Digital gestützter Unterricht für mehr Motivation und bessere Lernergebnisse.
            </p>

          </div>



          <div className={styles.card}>

            <div className={`${styles.icon} ${styles.green}`}>
              📱
            </div>

            <h3 className={styles.greenText}>
              Lernen mit
              Tablets
            </h3>

            <p>
              Flexibel, digital und
              individuell – überall
              und jederzeit lernen.
            </p>

          </div>



          <div className={styles.card}>

            <div className={styles.icon}>
              🎓
            </div>

            <h3>
              Digitale
              Kompetenzen
            </h3>

            <p>
              Wir stärken wichtige
              Skills für die Schule,
              das Studium und die Berufswelt.
            </p>

          </div>


        </div>



        {/* SAĞ TARAF */}
        <div className={styles.textSide}>

          <p>
            Wir setzen auf innovative Technologien, um Lernen
            interaktiv, individuell und zukunftsorientiert zu gestalten.
            Mit Smartboards, Tablets und digitalen Lernplattformen
            fördern wir Neugier, Kreativität und digitale Kompetenzen
            – für eine starke Bildung von heute und morgen.
          </p>




        </div>


      </div>


    </section>
  );
}